// Uklady menu "⋮" w widoku posiedzenia i na liscie wynikow wyszukiwarki. Kolejnosc wierszy i separatory sa tu jawne
// (katalog meetingsActions.js nie ma pol kolejnosci; menu boczne idzie po nim w kolejnosci wpisow).
// Ikony grup leza w assets/icons/meetingsActions (staly prefiks w require).
// Uklady sa zamrozone: trafiaja do data() rodzica i bez tego przypadkowa mutacja zmienilaby uklad globalnie
// (Vue nie opakowuje obiektow nierozszerzalnych w proxy).
function deepFreeze(value) {
    Object.values(value).forEach(child => {
        if (child !== null && typeof child === "object") {
            deepFreeze(child);
        }
    });
    return Object.freeze(value);
}

const groups = {
    agenda: { type: "group", id: "agenda", name: "com.file.meeting-actions.group.agenda", icon: "edit-session-list", actionIds: [80, 70] },
    invitations: { type: "group", id: "invitations", name: "com.file.meeting-actions.group.invitations", icon: "paper-plane-top-regular", actionIds: [64, 65] },
    recordings: { type: "group", id: "recordings", name: "com.file.meeting-actions.group.recordings", icon: "record-vinyl", actionIds: [68, 67, 69] },
    protocol: { type: "group", id: "protocol", name: "com.file.meeting-actions.group.protocol", icon: "add-protocol", actionIds: [50, 51, 60] },
    votings: { type: "group", id: "votings", name: "com.file.meeting-actions.group.votings", icon: "voting", actionIds: [75, 95] },
    copies: { type: "group", id: "copies", name: "com.file.meeting-actions.group.copies", icon: "duplicate", actionIds: [40, 30] },
};

// tryb zwykly; "fallback" to miejsce na widoczne akcje, ktorych nie ma w ukladzie
export const sessionViewMenuLayout = deepFreeze({
    mode: "normal",
    items: [
        { type: "action", id: 20 },
        groups.agenda,
        groups.invitations,
        groups.recordings,
        groups.protocol,
        groups.votings,
        { type: "action", id: 97 },
        { type: "separator" },
        { type: "action", id: 90 },
        groups.copies,
        { type: "action", id: 99 },
        { type: "action", id: 98 },
        { type: "fallback" },
        { type: "separator" },
        { type: "action", id: 15 },
        { type: "action", id: 16 },
    ],
});

// tryb interaktywny (bez separatorow)
export const sessionViewInteractiveMenuLayout = deepFreeze({
    mode: "interactive",
    items: [
        { type: "action", id: 96 },
        groups.votings,
        groups.protocol,
        { type: "action", id: 10 },
        { type: "action", id: 90 },
        groups.recordings,
        { type: "fallback" },
    ],
});

// lista wynikow wyszukiwarki posiedzen; zbior akcji wyznacza SessionSearch.checkSkippedActions
// (tu nie ma 15, 16, 20, 30, 80, 96, wiec Porzadek obrad i Kopie i szablony splaszczaja sie do jednej akcji)
export const sessionSearchMenuLayout = deepFreeze({
    mode: "normal",
    items: [
        { type: "action", id: 0 },
        { type: "action", id: 10 },
        groups.agenda,
        groups.invitations,
        groups.recordings,
        groups.protocol,
        groups.votings,
        { type: "action", id: 97 },
        { type: "separator" },
        { type: "action", id: 90 },
        groups.copies,
        { type: "action", id: 99 },
        { type: "action", id: 98 },
        { type: "fallback" },
        { type: "separator" },
        { type: "action", id: 100 },
    ],
});
